import { BaseDto } from "../base/baseDto.model";
import { CaracteristicaPropiedad } from "./caracteristicaPropiedad.model";

export class PropiedadCaracteristicaPropiedadDto {
    
    public id: number= 0
    public caracteristica = new BaseDto 
    public cantidad: number = 0
}